export default function Logo ({handleNavigate}) {


  
  return (
    
    <div className='nav-item-logo' onClick={() => handleNavigate('/')}>LOGO</div>
  )
}